import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from './baseTypes';
import { getTreatmentApproaches, getTreatmentApproachInterventions } from '@uplift/api';


export const useTreatmentApproachesQuery = (opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'treatmentApproaches' ],
    queryFn: async () => {
      const response = await getTreatmentApproaches();

      return response.data;
    },
    ...opts,
  });
};


export const useTreatmentApproachInterventionsQuery = (treatmentApproachId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'treatmentApproaches', treatmentApproachId, 'interventions' ],
    queryFn: async () => {
      const response = await getTreatmentApproachInterventions(treatmentApproachId);

      return response.data;
    },
    ...opts,
  });
};
